import { render, staticRenderFns } from "./r-edu-tip.vue?vue&type=template&id=213bb8c2&scoped=true"
import script from "./r-edu-tip.vue?vue&type=script&setup=true&lang=js"
export * from "./r-edu-tip.vue?vue&type=script&setup=true&lang=js"
import style0 from "./r-edu-tip.vue?vue&type=style&index=0&id=213bb8c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213bb8c2",
  null
  
)

export default component.exports